module.exports = __webpack_public_path__ + "img/algeria-logo-icon.39795283.png";